import React, { SyntheticEvent, useMemo } from 'react';
import { AutocompleteRenderInputParams, TextField } from '@mui/material';
import LoadedOptionsTypeahead from '../../../../../muiComponents/LoadedOptionsTypeahead';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import { AccountManagementSegmentState } from '../../../../../types/zinantis/members/membersType';
import { typeaheadFilterInputStyles } from '../../../../../utils/zinantis/members/membersUtils';

const TypesFilter = () => {
    const translate = useTranslate();
    const { accountManagementSegments, updateFilters, filters } =
        useZinantisMembers();

    const options = useMemo(() => {
        return [
            ...accountManagementSegments,
            { id: '0', name: translate('other-rest') },
        ];
    }, [accountManagementSegments]);

    return (
        <LoadedOptionsTypeahead
            idValueKey='id'
            optionsLabelKey='name'
            options={options}
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    variant='standard'
                    {...params}
                    placeholder={translate('type_connection')}
                    sx={typeaheadFilterInputStyles}
                />
            )}
            handleChange={(
                _event: SyntheticEvent<Element, Event>,
                newValue: AccountManagementSegmentState | null
            ) => {
                updateFilters(
                    'idAccountManagementSegment',
                    newValue ? parseInt(newValue.id) : null
                );
            }}
            value={
                filters.idAccountManagementSegment !== null
                    ? options.find(
                          acc =>
                              parseInt(acc.id) ===
                              filters.idAccountManagementSegment
                      )
                    : null
            }
            getOptionLabel={(option: AccountManagementSegmentState) =>
                option.name
            }
        />
    );
};

export default TypesFilter;
